import React from 'react' // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { getCookie } from '../helpers/CookieHandler'

class InputGroup extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      active: props.field.value && props.field.value.length > 0
    }

    this.handleBlur = this.handleBlur.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
  }

  componentWillReceiveProps = nextProps => {
    this.setState({ active: nextProps.field.value && nextProps.field.value.length > 0 })
  }

  handleBlur (e, field) {
    this.setState({ active: e.target.value.length !== 0 })
    this.props.validate(e, field)
    this.props.onBlur && this.props.onBlur()
  }

  handleFocus () {
    this.setState({ active: true })
    this.props.onFocus && this.props.onFocus()
  }

  translateValidationError = (err) => {
    const standardErrorTranslation = {
      phoneValidation: [
        { lang: 'en', value: 'must be a valid phone number' },
        { lang: 'pl', value: 'musi być prawidłowym numerem telefonu' },
        { lang: 'de', value: 'muss eine gültige Telefonnummer sein' },
        { lang: 'es', value: 'debe ser un número de teléfono válido' },
        { lang: 'pt', value: 'deve ser um número de telefone válido' },
        { lang: 'tr', value: 'geçerli bir telefon numarası olmalı' },
        { lang: 'fr', value: 'doit être un numéro de téléphone valide' },
        { lang: 'ch', value: 'must be a valid phone number' },
        { lang: 'ja', value: 'must be a valid phone number' }
      ],
      emailValidation: [
        { lang: 'en', value: 'must be a valid email address' },
        { lang: 'pl', value: 'musi być prawidłowym adresem e-mail' },
        { lang: 'de', value: 'muss eine gültige E-Mail-Adresse sein' },
        { lang: 'es', value: 'debe ser una dirección de correo electrónico válida' },
        { lang: 'pt', value: 'deve ser um endereço de e-mail válido' },
        { lang: 'tr', value: 'geçerli bir e-posta adresi olmalı' },
        { lang: 'fr', value: 'doit être une adresse e-mail valide' },
        { lang: 'ch', value: 'must be a valid email address' },
        { lang: 'ja', value: 'must be a valid email address' }
      ]
    }

    let sessionLang = 'en'
    const cookieLang = getCookie('welcomeLanguage')
    if (cookieLang && cookieLang.length === 2) {
      sessionLang = cookieLang
    }

    var result = err

    if (err.includes('must be a valid phone number')) {
      result = result.replace('must be a valid phone number',
        standardErrorTranslation.phoneValidation.filter(item => item.lang === sessionLang)[0].value)
    }

    if (err.includes('must be a valid email address')) {
      result = result.replace('must be a valid email address',
        standardErrorTranslation.emailValidation.filter(item => item.lang === sessionLang)[0].value)
    }

    return result
  }

  render () {
    const { label, type, placeholder, readonly, field, validate, onChange, onKeyDown, maxLength, styles , disabled  } = this.props

    let required = ((field.rules.required !== undefined) && (field.rules.required.required === true || field.rules.required.required !== false))
    if (!field.rules.required) {
      required = false
    }

    field.errors = field.errors || []
    const hasErrors = field.errors.length > 0

    const { active } = this.state

    return (
      <div className={classNames('react-floating-label-input', {
        active,
        'form-group': true,
        'has-danger': hasErrors
      })}
      >
        <div className='fli-container'>

          <label
            htmlFor={field.name}
            className={classNames(active ? 'input-float-label' : '', { 'input-float-label-error': hasErrors })}
          >
            {(label || field.rules.title) + (required ? '*' : '')}
          </label>

          <input
            id={field.name}
            name={field.name}
            type={type}
            placeholder={placeholder || ''}
            readOnly={readonly}
            className={classNames('form-control', { 'form-control-danger': hasErrors })}
            value={field.value}
            onBlur={e => this.handleBlur(e, field)}
            onFocus={this.handleFocus}
            onChange={function (e) {
              validate(e, field)
              if (onChange != null) {
                onChange(e, field)
              }
            }}
            onKeyDown={function (e) {
              if (onKeyDown != null) {
                onKeyDown(e, field)
              }
            }}
            maxLength={maxLength}
            style={styles}
            disabled={disabled}
          />
        </div>
        {field.errors.map((error, i) => <div key={i} className='form-control-feedback'>{this.translateValidationError(error)}</div>)}
      </div>
    )
  }
}

InputGroup.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  readonly: PropTypes.bool.isRequired,
  field: PropTypes.shape({
    value: PropTypes.string.isRequired,
    rules: PropTypes.any.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  validate: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  maxLength: PropTypes.number,
  styles: PropTypes.object,
  disbled: PropTypes.bool
}

InputGroup.defaultProps = {
  type: 'text',
  readonly: false,
  styles: {},
  disabled: false
}

export default InputGroup



// WEBPACK FOOTER //
// ./src/forms/InputGroup.js